<!-- Topic Selection -->
@if (!inlineEditMode) {
<div class="section topic-selection">
  <div class="label-wrapper">
    <h4>{{ 'pages.service.infoRequest.topicLabel' | translate }}</h4>
    <app-tooltip text="infoRequestTopic" />
  </div>
  <div class="topic-chips">
    @for (topic of topics; track topic.topicType) {
      <button
        class="topic-chip"
        [ngClass]="{ selected: selectedTopic?.topicType === topic.topicType }"
        (click)="selectTopic(topic)">
        {{ topic.name }}
      </button>
    }
  </div>

</div>
}

<!-- Dynamic Form Fields -->
@if (selectedTopic) {
  @if (inlineEditMode) {
    <div class="inline-topic-chip">{{ labels.field('requestContent', 'selectedTopic') }} - {{ selectedTopic.name }}</div>
  }
  <form class="section topic-form" [class.inline-edit]="inlineEditMode" [formGroup]="form">
    <div formGroupName="topicFields">
      <!-- Global fields (blockIndex = 0) -->
      @if (primaryGlobalFields.length > 0) {
        @if (getGlobalSectionTitle() && !inlineEditMode) {
          <div class="block-section-heading-wrapper">
            <h5 class="block-section-heading">{{ getGlobalSectionTitle() }}</h5>
            @if (getGlobalSectionTooltip()) {
              <app-tooltip [text]="getGlobalSectionTooltip()" />
            }
          </div>
        }
        <div class="block-card">
          @if (!hasMultipleBlocks && allFieldsAreGlobal) {
            <div class="block-header">
              <h5>{{ getBlockCardTitle() }} Nr. 1</h5>
            </div>
          }
          <div class="block-fields">
          @for (field of primaryGlobalFields; track field.fieldKey) {
            @if (field.fieldType === 'section_title') {
            } @else {
            <div class="field-wrapper">
              @if (field.fieldType !== 'toggle' && field.fieldType !== 'checkbox') {
              <div class="label-wrapper">
                <label class="form-label" [for]="field.fieldKey">
                  {{ field.fieldLabel }}
                </label>
                @if (field.tooltipText) {
                  <app-tooltip [text]="field.tooltipText" />
                }
              </div>
              }

              @if (field.fieldType === 'text') {
                <input
                  class="form-control lna"
                  [id]="field.fieldKey"
                  [formControlName]="field.fieldKey"
                  [maxlength]="field.maxLength || 500"
                  [ngClass]="{ invalid: shouldRenderError(field.fieldKey, topicFieldsGroup) }" />
              } @else if (field.fieldType === 'textarea') {
                <div class="textarea-wrapper">
                  <textarea
                    class="form-control lna"
                    [id]="field.fieldKey"
                    [formControlName]="field.fieldKey"
                    [maxlength]="field.maxLength || 2000"
                    [ngClass]="{ invalid: shouldRenderError(field.fieldKey, topicFieldsGroup) }"></textarea>
                  <p class="length" [ngClass]="{ invalid: (topicFieldsGroup.get(field.fieldKey)?.value?.length || 0) > (field.maxLength || 2000) }">
                    {{ topicFieldsGroup.get(field.fieldKey)?.value?.length || 0 }}/{{ field.maxLength || 2000 }}
                  </p>
                </div>
              } @else if (field.fieldType === 'radio' || field.fieldType === 'radio_button') {
                <div class="radio-buttons" [ngClass]="{ invalid: shouldRenderError(field.fieldKey, topicFieldsGroup) }">
                  <div class="radio-wrapper">
                    <input
                      type="radio"
                      [id]="field.fieldKey + '_yes'"
                      [formControlName]="field.fieldKey"
                      value="true" />
                    <label [for]="field.fieldKey + '_yes'">{{ 'pages.service.infoRequest.yes' | translate }}</label>
                  </div>
                  <div class="radio-wrapper">
                    <input
                      type="radio"
                      [id]="field.fieldKey + '_no'"
                      [formControlName]="field.fieldKey"
                      value="false" />
                    <label [for]="field.fieldKey + '_no'">{{ 'pages.service.infoRequest.no' | translate }}</label>
                  </div>
                </div>
              } @else if (field.fieldType === 'checkbox' || field.fieldType === 'toggle') {
                <div class="checkbox-wrapper">
                  <input
                    class="form-check-input lna checkbox"
                    [id]="field.fieldKey"
                    type="checkbox"
                    [ngClass]="{ invalid: shouldRenderError(field.fieldKey, topicFieldsGroup) }"
                    [formControlName]="field.fieldKey" />
                  <label class="checkbox-label" [for]="field.fieldKey">
                    {{ field.fieldLabel }}
                  </label>
                </div>
              } @else if (field.fieldType === 'number') {
                <input
                  class="form-control lna"
                  type="number"
                  [id]="field.fieldKey"
                  [formControlName]="field.fieldKey"
                  [ngClass]="{ invalid: shouldRenderError(field.fieldKey, topicFieldsGroup) }" />
              } @else {
                <input
                  class="form-control lna"
                  [id]="field.fieldKey"
                  [formControlName]="field.fieldKey"
                  [maxlength]="field.maxLength || 500"
                  [ngClass]="{ invalid: shouldRenderError(field.fieldKey, topicFieldsGroup) }" />
              }

              @if (getErrorMessage(field.fieldKey, topicFieldsGroup); as errorMessage) {
                <div class="error-wrapper">
                  <small class="error-message" aria-live="polite">
                    {{ errorMessage | translate }}
                  </small>
                </div>
              }
            </div>
            }
          }

            <!-- Table sub-section for block 1 (when !hasMultipleBlocks && allFieldsAreGlobal) -->
            @if (tableSection && !hasMultipleBlocks && allFieldsAreGlobal) {
              <div class="table-section-header">
                <p class="table-section-title">
                  {{ tableSection.title.sectionTitle || tableSection.title.fieldLabel }}
                </p>
                @if (getTableSectionTooltip()) {
                  <app-tooltip [text]="getTableSectionTooltip()" />
                }
              </div>
              <div class="table-section">
                <div class="table-border">
                  <div class="table-row table-header-row">
                    <div class="table-row-fields">
                      @for (field of tableSection.fields; track field.fieldKey) {
                        <div class="table-header-cell">{{ field.fieldLabel }}</div>
                      }
                    </div>
                    <div class="table-row-actions"></div>
                  </div>
                  <div class="table-rows">
                    @for (row of getTableRows(1); track $index; let rowIdx = $index) {
                      <div class="table-row">
                        <div class="table-row-fields">
                          @for (field of tableSection.fields; track field.fieldKey) {
                            <div class="table-cell">
                              <input
                                class="form-control lna"
                                [maxlength]="field.maxLength || 255"
                                [(ngModel)]="row[field.fieldKey]"
                                [ngModelOptions]="{ standalone: true }"
                                (ngModelChange)="onTableCellChange()" />
                            </div>
                          }
                        </div>
                        <div class="table-row-actions">
                          @if (rowIdx > 0) {
                            <button class="delete-block-btn" (click)="removeTableRow(1, rowIdx)">
                              <img alt="delete" src="assets/images/delete-icon.svg" />
                            </button>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
                <div class="add-row-wrapper">
                  <button class="add-block-btn" (click)="addTableRow(1)">
                    <img alt="add" src="assets/images/add-icon-black.svg" />
                    {{ 'pages.service.infoRequest.addAddress' | translate }}
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
      }

      <!-- Block fields (repeatable blocks) -->
      @if (hasMultipleBlocks && (blockFields.length > 0 || tableSection) && !inlineEditMode) {
        <div class="block-section-heading-wrapper">
          <h5 class="block-section-heading">{{ getBlockSectionTitle() }}</h5>
          @if (getBlockSectionTooltip()) {
            <app-tooltip [text]="getBlockSectionTooltip()" />
          }
        </div>
      }
      @if (blockFields.length > 0 || (tableSection && hasMultipleBlocks)) {
      @for (blockNum of [].constructor(hasMultipleBlocks ? blockCount : 1); track $index; let i = $index) {
        <div class="block-section" [class.block-card]="hasMultipleBlocks || !allFieldsAreGlobal">
          @if (hasMultipleBlocks || !allFieldsAreGlobal) {
            <div class="block-header">
              <h5>{{ getBlockCardTitle() }} Nr. {{ i + 1 }}</h5>
              @if (hasMultipleBlocks && blockCount > 1) {
                <button class="delete-block-btn" (click)="removeBlock(i + 1)">
                  <img alt="delete" src="assets/images/delete-icon.svg" />
                </button>
              }
            </div>
          }

          <div class="block-fields">
            @for (field of blockFields; track field.fieldKey) {
              @if (isFieldVisible(field)) {
                @if (field.fieldType === 'section_title') {
                  @if (!hasMultipleBlocks) {
                    <h5 class="section-title">{{ field.sectionTitle || field.fieldLabel }}</h5>
                  }
                } @else {
                <div class="field-wrapper">
                  @if (field.fieldType !== 'toggle' && field.fieldType !== 'checkbox') {
                  <div class="label-wrapper">
                    <label class="form-label" [for]="getControlKey(field, i + 1)">
                      {{ field.fieldLabel }}
                    </label>
                    @if (field.tooltipText) {
                      <app-tooltip [text]="field.tooltipText" />
                    }
                  </div>
                  }

                  @if (field.fieldType === 'text') {
                    <input
                      class="form-control lna"
                      [id]="getControlKey(field, i + 1)"
                      [formControlName]="getControlKey(field, i + 1)"
                      [maxlength]="field.maxLength || 500"
                      [ngClass]="{ invalid: shouldRenderFieldError(field, i + 1) }" />
                  } @else if (field.fieldType === 'textarea') {
                    <div class="textarea-wrapper">
                      <textarea
                        class="form-control lna"
                        [id]="getControlKey(field, i + 1)"
                        [formControlName]="getControlKey(field, i + 1)"
                        [maxlength]="field.maxLength || 2000"
                        [ngClass]="{ invalid: shouldRenderFieldError(field, i + 1) }"></textarea>
                      <p class="length" [ngClass]="{ invalid: (getFieldValue(field.fieldKey, i + 1).length) > (field.maxLength || 2000) }">
                        {{ getFieldValue(field.fieldKey, i + 1).length }}/{{ field.maxLength || 2000 }}
                      </p>
                    </div>
                  } @else if (field.fieldType === 'radio' || field.fieldType === 'radio_button') {
                    <div class="radio-buttons" [ngClass]="{ invalid: shouldRenderFieldError(field, i + 1) }">
                      <div class="radio-wrapper">
                        <input
                          type="radio"
                          [id]="getControlKey(field, i + 1) + '_yes'"
                          [formControlName]="getControlKey(field, i + 1)"
                          value="true" />
                        <label [for]="getControlKey(field, i + 1) + '_yes'">{{ 'pages.service.infoRequest.yes' | translate }}</label>
                      </div>
                      <div class="radio-wrapper">
                        <input
                          type="radio"
                          [id]="getControlKey(field, i + 1) + '_no'"
                          [formControlName]="getControlKey(field, i + 1)"
                          value="false" />
                        <label [for]="getControlKey(field, i + 1) + '_no'">{{ 'pages.service.infoRequest.no' | translate }}</label>
                      </div>
                    </div>
                  } @else if (field.fieldType === 'checkbox' || field.fieldType === 'toggle') {
                    <div class="checkbox-wrapper">
                      <input
                        class="form-check-input lna checkbox"
                        [id]="getControlKey(field, i + 1)"
                        type="checkbox"
                        [formControlName]="getControlKey(field, i + 1)" />
                      <label class="checkbox-label" [for]="getControlKey(field, i + 1)">
                        {{ field.fieldLabel }}
                      </label>
                    </div>
                  } @else if (field.fieldType === 'number') {
                    <input
                      class="form-control lna"
                      type="number"
                      [id]="getControlKey(field, i + 1)"
                      [formControlName]="getControlKey(field, i + 1)"
                      [ngClass]="{ invalid: shouldRenderFieldError(field, i + 1) }" />
                  } @else {
                    <input
                      class="form-control lna"
                      [id]="getControlKey(field, i + 1)"
                      [formControlName]="getControlKey(field, i + 1)"
                      [maxlength]="field.maxLength || 500"
                      [ngClass]="{ invalid: shouldRenderFieldError(field, i + 1) }" />
                  }

                  @if (getFieldErrorMessage(field, i + 1); as errorMessage) {
                    <div class="error-wrapper">
                      <small class="error-message" aria-live="polite">
                        {{ errorMessage | translate }}
                      </small>
                    </div>
                  }
                </div>
                }
              }
            }
            <!-- Table sub-section per block (e.g. address table in MilitaryService) -->
            @if (tableSection) {
              <div class="table-section-header">
                <p class="table-section-title">
                  {{ tableSection.title.sectionTitle || tableSection.title.fieldLabel }}
                </p>
                @if (getTableSectionTooltip()) {
                  <app-tooltip [text]="getTableSectionTooltip()" />
                }
              </div>
              <div class="table-section">
                <div class="table-border">
                  <div class="table-row table-header-row">
                    <div class="table-row-fields">
                      @for (field of tableSection.fields; track field.fieldKey) {
                        <div class="table-header-cell">{{ field.fieldLabel }}</div>
                      }
                    </div>
                    <div class="table-row-actions"></div>
                  </div>
                  <div class="table-rows">
                    @for (row of getTableRows(i + 1); track $index; let rowIdx = $index) {
                      <div class="table-row">
                        <div class="table-row-fields">
                          @for (field of tableSection.fields; track field.fieldKey) {
                            <div class="table-cell">
                              <input
                                class="form-control lna"
                                [maxlength]="field.maxLength || 255"
                                [(ngModel)]="row[field.fieldKey]"
                                [ngModelOptions]="{ standalone: true }"
                                (ngModelChange)="onTableCellChange()" />
                            </div>
                          }
                        </div>
                        <div class="table-row-actions">
                          @if (rowIdx > 0) {
                            <button class="delete-block-btn" (click)="removeTableRow(i + 1, rowIdx)">
                              <img alt="delete" src="assets/images/delete-icon.svg" />
                            </button>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
                <div class="add-row-wrapper">
                  <button class="add-block-btn" (click)="addTableRow(i + 1)">
                    <img alt="add" src="assets/images/add-icon-black.svg" />
                    {{ 'pages.service.infoRequest.addAddress' | translate }}
                  </button>
                </div>
              </div>
            }
          </div>

        </div>
      }
      }

      <!-- Add block button -->
      <!-- Additional blocks for single-block topics -->
      @if (!hasMultipleBlocks && blockCount > 1) {
        @for (blockNum of [].constructor(blockCount - 1); track $index; let i = $index) {
          <div class="block-section block-card">
            <div class="block-header">
              <h5>{{ getBlockCardTitle() }} Nr. {{ i + 2 }}</h5>
              <button class="delete-block-btn" (click)="removeBlock(i + 2)">
                <img alt="delete" src="assets/images/delete-icon.svg" />
              </button>
            </div>
            <div class="block-fields">
              @for (field of blockTemplateFields; track field.fieldKey) {
                @if (field.fieldType !== 'section_title') {
                  <div class="field-wrapper">
                    @if (field.fieldType !== 'toggle' && field.fieldType !== 'checkbox') {
                      <div class="label-wrapper">
                        <label class="form-label" [for]="getControlKey(field, i + 2)">
                          {{ field.fieldLabel }}
                        </label>
                      </div>
                    }
                    @if (field.fieldType === 'textarea') {
                      <div class="textarea-wrapper">
                        <textarea
                          class="form-control lna"
                          [id]="getControlKey(field, i + 2)"
                          [formControlName]="getControlKey(field, i + 2)"
                          [maxlength]="field.maxLength || 2000"></textarea>
                        <p class="length">
                          {{ getFieldValue(field.fieldKey, i + 2).length }}/{{ field.maxLength || 2000 }}
                        </p>
                      </div>
                    } @else if (field.fieldType === 'checkbox' || field.fieldType === 'toggle') {
                      <div class="checkbox-wrapper">
                        <input
                          class="form-check-input lna checkbox"
                          [id]="getControlKey(field, i + 2)"
                          type="checkbox"
                          [formControlName]="getControlKey(field, i + 2)" />
                        <label class="checkbox-label" [for]="getControlKey(field, i + 2)">{{ field.fieldLabel }}</label>
                      </div>
                    } @else if (field.fieldType === 'radio' || field.fieldType === 'radio_button') {
                      <div class="radio-buttons">
                        <div class="radio-wrapper">
                          <input type="radio" [id]="getControlKey(field, i + 2) + '_yes'" [formControlName]="getControlKey(field, i + 2)" value="true" />
                          <label [for]="getControlKey(field, i + 2) + '_yes'">{{ 'pages.service.infoRequest.yes' | translate }}</label>
                        </div>
                        <div class="radio-wrapper">
                          <input type="radio" [id]="getControlKey(field, i + 2) + '_no'" [formControlName]="getControlKey(field, i + 2)" value="false" />
                          <label [for]="getControlKey(field, i + 2) + '_no'">{{ 'pages.service.infoRequest.no' | translate }}</label>
                        </div>
                      </div>
                    } @else {
                      <input
                        class="form-control lna"
                        [id]="getControlKey(field, i + 2)"
                        [formControlName]="getControlKey(field, i + 2)"
                        [maxlength]="field.maxLength || 500" />
                    }
                  </div>
                }
              }
              <!-- Table sub-section for additional blocks -->
              @if (tableSection) {
                <div class="table-section-header">
                  <p class="table-section-title">
                    {{ tableSection.title.sectionTitle || tableSection.title.fieldLabel }}
                  </p>
                  @if (getTableSectionTooltip()) {
                    <app-tooltip [text]="getTableSectionTooltip()" />
                  }
                </div>
                <div class="table-section">
                  <div class="table-border">
                    <div class="table-row table-header-row">
                      <div class="table-row-fields">
                        @for (field of tableSection.fields; track field.fieldKey) {
                          <div class="table-header-cell">{{ field.fieldLabel }}</div>
                        }
                      </div>
                      <div class="table-row-actions"></div>
                    </div>
                    <div class="table-rows">
                      @for (row of getTableRows(i + 2); track $index; let rowIdx = $index) {
                        <div class="table-row">
                          <div class="table-row-fields">
                            @for (field of tableSection.fields; track field.fieldKey) {
                              <div class="table-cell">
                                <input
                                  class="form-control lna"
                                  [maxlength]="field.maxLength || 255"
                                  [(ngModel)]="row[field.fieldKey]"
                                  [ngModelOptions]="{ standalone: true }"
                                  (ngModelChange)="onTableCellChange()" />
                              </div>
                            }
                          </div>
                          <div class="table-row-actions">
                            @if (rowIdx > 0) {
                              <button class="delete-block-btn" (click)="removeTableRow(i + 2, rowIdx)">
                                <img alt="delete" src="assets/images/delete-icon.svg" />
                              </button>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                  <div class="add-row-wrapper">
                    <button class="add-block-btn" (click)="addTableRow(i + 2)">
                      <img alt="add" src="assets/images/add-icon-black.svg" />
                      {{ 'pages.service.infoRequest.addAddress' | translate }}
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      }

      @if (canAddBlocks && blockCount < effectiveMaxBlocks) {
        <div class="add-block-wrapper">
          <button class="add-block-btn" (click)="addBlock()">
            <img alt="add" src="assets/images/add-icon-black.svg" />
            {{ getAddBlockLabel() }}
          </button>
        </div>
      }
    </div>

  </form>
}

<!-- Documents -->
@if (!inlineEditMode) {
<div class="section file-section">
  <div class="label-wrapper">
    <h4>{{ 'pages.service.infoRequest.documents' | translate }}</h4>
    <app-tooltip text="infoRequestDocuments" />
  </div>
  <p class="file-hint">{{ 'pages.service.infoRequest.documentsHint' | translate }}</p>
  <app-file-upload
    #documentUpload
    [type]="documentFileType"
    [associatedEntityId]="application?.id || ''"
    [existingFiles]="existingDocumentFiles"
    [isEditMode]="true"
    [isSubmitting]="isSubmittingFiles"
    [showDescription]="true"
    [showBackofficeNote]="false"
    [showTerm]="false"
    [maxFiles]="10"
    [savedFiles]="savedDocumentFiles"
    (uploading)="fileUploading.emit($event)"
    (filesChanged)="documentsChanged.emit($event)"
    (fileDeleted)="markFilesChanged()"
    (filesAdded)="markFilesChanged()" />
</div>
}

<!-- Actions -->
@if (!inlineEditMode) {
<app-service-form-actions
  [isFirstStep]="true"
  [isNew]="!isDraftSaved"
  [showSaveDraft]="true"
  [isSubmitting]="isSaving"
  (exit)="onExit()"
  (saveDraft)="saveDraft()"
  (deleteDraft)="onDelete()"
  (continue)="goToNextStep()" />
}

@if (!inlineEditMode) {
<!-- Confirm Topic Change Modal -->
<app-confirm-modal
  [isOpen]="isConfirmTopicChange"
  (confirm)="confirmTopicChange()"
  (cancel)="cancelTopicChange()"
  title="changeTopicTitle"
  bodyText="changeTopicWarning"
  confirmText="changeTopicConfirm"
  denyText="cancel" />

<!-- Confirm Delete Modal -->
<app-confirm-modal
  [isOpen]="isConfirmDelete"
  (confirm)="confirmDelete()"
  (cancel)="isConfirmDelete = false"
  title="deleteDraftConfirmTitle"
  bodyText="deleteDraftConfirmBody"
  confirmText="delete"
  denyText="cancel" />

<!-- Confirm Exit Modal -->
<app-confirm-modal
  [isOpen]="isConfirmExit"
  (confirm)="confirmExit()"
  (cancel)="isConfirmExit = false"
  title="unsavedChanges"
  bodyText="unsavedChangesBody"
  confirmText="continue"
  denyText="cancelBack" />

<!-- Select responsible structural unit (operators belonging to several units) -->
<app-select-structural-unit-modal
  [isOpen]="isSelectStructuralUnitModalOpen"
  [units]="userStructuralUnits"
  (confirm)="onStructuralUnitSelected($event)"
  (cancel)="onSelectStructuralUnitCancelled()" />
}
